import React, { useState } from "react";
import RequestService from "../../services/request.service";

import AuthService from "../../features/auth/auth.service";

import { Button, Modal, Table, Form } from 'react-bootstrap'



import { toast } from 'react-toastify'


import Dialog from '../../services/Dialogs'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import moment from 'moment'

import Pagination from "../../services/Pagination";



import { useNavigate } from "react-router-dom";


import ModalAnexos from '../Tramites/ModalAnexos'

import { SERVER_ } from  '../../config';




import ModalCargaMasiva from './Modales/ModalCargaMasiva'
import ModalInformeAseguramiento from './Modales/ModalInformeAseguramiento'




const Aseguramiento = () =>{


    const currentUser  = AuthService.getCurrentUser();


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (tramite:any) =>{
    setDatosAseguramiento({ ...DATOS_ASEGURAMIENTO })
    setTramiteSeleccionado(tramite)
    setShow(true);
  }


    const dialog = new Dialog()

    let navigate = useNavigate()

  const [ ultimos, setUltimos ] = useState<any>([])
  const ultimosTramites = async () =>{
    try{
      let res = await RequestService.getEndPoint('aseguramiento/estrategias/ultimos')
      setUltimos(res.data)
    }
    catch(e){
      toast.error('Error al cargar los trámites para Verificación')
    }
  }


  React.useEffect(() => {
    ultimosTramites()
  }, []);


  const [ tramite_seleccionado, setTramiteSeleccionado ] = useState<any>({})
  const DATOS_ASEGURAMIENTO : any = {
                monto_aseguramiento_final : 0,
                sueldo_trabajador_aseguramiento : 0,
                fecha_baja_nuevo : "",
                fecha_alta_nuevo : "",
                fecha_aseguramiento : "",
                costo_alta : 0,
  }
  const [ datos_aseguramiento, setDatosAseguramiento ] = useState<any>({ ...DATOS_ASEGURAMIENTO })



  const asegurarTramite = async (e) =>{
    try{
          await dialog.open({
            accept: 'Asegurar',
            dialogClass: '',
            message: 'Espera',
            soundAccept: 'https://assets.stoumann.dk/audio/accept.mp3',
            soundOpen: 'https://assets.stoumann.dk/audio/open.mp3',
            target: e.target,
            template: `
                    <p>¿Confirmas la siguiente información?:</p>

                    <dl>
                        <dt>Monto de Aseguramiento</dt>
                        <dd>$ `+datos_aseguramiento.monto_aseguramiento_final+`</dd>

                        <dt>Sueldo de Aseguramiento</dt>
                        <dd>$ `+datos_aseguramiento.sueldo_trabajador_aseguramiento+`</dd>

                        <dt>Fecha de Alta</dt>
                        <dd>`+moment(datos_aseguramiento.fecha_alta_nuevo).format('YYYY-MM-DD')+`</dd>

                        <dt>Fecha de Baja</dt>
                        <dd>`+moment(datos_aseguramiento.fecha_baja_nuevo).format('YYYY-MM-DD')+`</dd>

                        <dt>Fecha de Aseguramiento</dt>
                        <dd>`+moment(datos_aseguramiento.fecha_aseguramiento).format('YYYY-MM-DD')+`</dd>

                        <dt>Costo de Alta</dt>
                        <dd>$ `+datos_aseguramiento.costo_alta+`</dd>
                    </dl>

            `
          })
          let respuesta : any = await dialog.waitForUser()

          if(respuesta){
            let res = await RequestService.update('asegurar_tramite/'+tramite_seleccionado.uuid, { datos_aseguramiento : datos_aseguramiento} )
            toast.success('Este Trámite ha sido asegurado')
            ultimosTramites()
            setShow(false)
          }
    }
    catch(error){
      toast.error('Error')
    }
  }

    // const atenderTramite = async (uuid_tramite:string)=>{
    //   try{
    //     if(await dialog.confirm('¿Estás seguro?',{})){
    //       let res = await RequestService.create('verificacion_telefonica/tomar_verificacion/'+uuid_tramite,{})
    //       toast.success('Tu tomaste el control del trámite')
    //       navigate("../verificacion/"+uuid_tramite, { replace: true })
    //     }
    //   }
    //   catch(e){
    //     toast.error('Error al tratar de tomar el control del trámite')
    //     ultimosTramites()
    //   }
    // }

  const [ uuid_tramite_modal, setUUIDTramiteSeleccionado ] = useState<any>('')

  const [ showModalAnexos, setShowModalAnexos ] = useState<any>(false)

  const onHideModalAnexos = () => {
    setShowModalAnexos(false)
  }

            
  const detalleAnexos = (uuid_tramite:string)=>{
      setShowModalAnexos(true)
      setUUIDTramiteSeleccionado(uuid_tramite)
  }

  const descarga_aseguramientos = async() =>{
    window.open(SERVER_+'descarga_aseguramientos/'+currentUser.uuid)
    // let response = await RequestService.create('descarga_aseguramientos',{})
    // const url = window.URL.createObjectURL(new Blob([response.data]));
    // const link = document.createElement('a');
    // link.href = url;
    // link.setAttribute('download','exsi.xlsx'); //or any other extension
    // document.body.appendChild(link);
    // link.click();
  }




  const [showModalCarga, setShowModalCarga] = useState(false);


  const modalCarga = ()=>{
    setShowModalCarga(true)
  }

  const handleCloseModalCarga = () =>{ 
    ultimosTramites()
    setShowModalCarga(false)
  }

// <ModalInformeAseguramiento showModal={} handleClose={} />

  const [showModalInforme, setShowModalInforme] = useState(false);


  const modalInforme = ()=>{
    setShowModalInforme(true)
  }

  const handleCloseModalInforme = () =>{ 
    ultimosTramites()
    setShowModalInforme(false)
  }

      return (
             
          <>
              <div className="container">
                  
                  <h2>Aseguramiento de Trámites</h2>
                  <hr />


                  {
                    ultimos.length === 0 && (

                          <React.Fragment>
                            {
                              // JSON.stringify(tramite.tramite)
                            }

                              
                            <div className="alert alert-warning" role="alert">
                              <h6>Sin Trámites</h6>
                              <p>No tienes trámites que Asegurar</p>
                            </div>


                          </React.Fragment>

                    )
                  }


                  {
                    ultimos.length > 0 && (

                          <React.Fragment>
                            {
                              // JSON.stringify(tramite.tramite)
                            }

                              <ul className="list-inline">
                                <li className="list-inline-item"><button type="button" onClick={descarga_aseguramientos} className="btn btn-link"><i className="fa fa-download" /> Descargar Aseguramientos</button></li>
                                <li className="list-inline-item"><button type="button" onClick={modalInforme} className="btn btn-link"><i className="fa fa-upload" /> Informe de Aseguramiento</button></li>
                                <li className="list-inline-item"><button type="button" onClick={modalCarga} className="btn btn-link"><i className="fa fa-upload" /> Cargar Layout</button></li>
                                <li className="list-inline-item"><button type="button" onClick={()=>{window.open(SERVER_+'aseguramiento/layout')}} className="btn btn-link"><i className="fa fa-file-excel-o" /> Descargar Archivo Layout</button></li>
                              </ul>


                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th scope="col">Folio</th>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Sexo</th>
                                    <th scope="col"></th>
                                    <th scope="col">CURP</th>
                                    <th scope="col">RFC</th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    
                                  </tr>
                                </thead>
                                <tbody style={{fontSize:12}}>
                                  {
                                    ultimos.map( tramite =>
                                        <React.Fragment key={ Math.random().toString(36).substr(2, 9) }>

                                              <tr>
                                                <td className="v" width={140}>
                                                  <p className="nm"><b>{ tramite.folio }</b></p>
                                                </td>
                                                <td className="v">
                                                  <b>{ tramite.nombres } </b>
                                                  {
                                                     tramite.paterno + ' ' + tramite.materno
                                                  }
                                                </td>
                                                <td className="v" width={80}>
                                                    {tramite.sexo==='H'?'HOMBRE':'MUJER'}
                                                </td>
                                                <td className="v">
                                                  {
                                                    // JSON.stringify(tramite)
                                                    tramite.uuid
                                                  }

                                                              

                                                </td>
                                                <td className="v" width={150}>
                                                    {tramite.curp}
                                                </td>
                                                <td className="v" width={150}>
                                                    {tramite.rfc}
                                                </td>
                                                <td className="v" width={50}>
                                                    <Button onClick={()=>{detalleAnexos(tramite.uuid)}} className="nm" size="sm" variant="link"><i className="fa fa-folder" /></Button>
                                                </td>
                                                <td className="v">
                                                  {
                                                    // JSON.stringify(tramite.asegurado)
                                                  }
                                                  { tramite.asegurado === 1 && ( <i className="fa fa-check-circle" /> ) }
                                                </td>

                                                {
                                                  // <td className="v" width={150}>
                                                  //   <button onClick={()=>{handleShow(tramite)}} className="btn btn-link" > Asegurar</button>
                                                  // </td>
                                                }



                                              </tr>
                                          
                                        </React.Fragment>

                                    )
                                  }

                                </tbody>
                              </table>




                          </React.Fragment>

                    )
                  }


              </div>



      <Modal show={show} backdrop="static" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Aseguramiento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // JSON.stringify(tramite_seleccionado)
          }
          <h4>Información Personal</h4>
            <dl>
                <dt>Nombre</dt>
                <dd>
                  <b>{tramite_seleccionado.nombres}</b> {tramite_seleccionado.paterno} {tramite_seleccionado.materno}
                </dd>

                <dt>CURP</dt>
                <dd>
                  <b>{tramite_seleccionado.curp}</b> 
                </dd>
                <dt>RFC</dt>
                <dd>
                  <b>{tramite_seleccionado.rfc||'No proporcionado'}</b>
                </dd>

                <dt>Sexo</dt>
                <dd>{tramite_seleccionado.sexo==='H'?'HOMBRE':'MUJER'}</dd>

                <dt>Fecha de Nacimiento</dt>
                <dd>{tramite_seleccionado.fecha_nacimiento}</dd>
            </dl>

            <h4>Información Laboral</h4>
            <dl>
                <dt>Fecha de baja del último Trabajo</dt>
                <dd>
                  {tramite_seleccionado.fecha_baja_anterior||'-'}
                </dd>
                <dt>Sueldo del Trabajador</dt>
                <dd>
                  {tramite_seleccionado.sueldo_trabajador||'$0.00'}
                </dd>
            </dl>



            <h4>Información de Aseguramiento</h4>


            <div className="row">
              <div className="col-sm">
                  <div className="mb-3">
                    <label htmlFor="monto_aseguramiento_final" className="form-label">Monto de Aseguramiento</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span> 
                      <input type="text" className="form-control" id="monto_aseguramiento_final" value={datos_aseguramiento.monto_aseguramiento_final} onBlur={e=>{ setDatosAseguramiento({ ...datos_aseguramiento, sueldo_trabajador_aseguramiento :  parseFloat(datos_aseguramiento.monto_aseguramiento_final) * (1.0452), monto_aseguramiento_final : parseFloat(e.target.value)  }) }} onChange={(e)=>{setDatosAseguramiento({ ...datos_aseguramiento, monto_aseguramiento_final : e.target.value })}} />
                    </div>
                  </div>
              </div>
              <div className="col-sm">
                  <div className="mb-3">
                    <label htmlFor="sueldo_trabajador_aseguramiento" className="form-label">Sueldo de Aseguramiento</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <input type="text" className="form-control" id="sueldo_trabajador_aseguramiento" readOnly={true} value={datos_aseguramiento.sueldo_trabajador_aseguramiento} onChange={(e)=>{setDatosAseguramiento({ ...datos_aseguramiento, sueldo_trabajador_aseguramiento : parseFloat(e.target.value) })}} />
                    </div>
                  </div>
              </div>
            </div>





            <div className="row">
              <div className="col-sm">
                  <div className="mb-3">
                    <label className="form-label">Fecha de Alta</label>
                    <DatePicker dateFormat="MMMM d, yyyy" minDate={new Date()} selected={datos_aseguramiento.fecha_alta_nuevo} className="form-control" onChange={(date)=>{setDatosAseguramiento({ ...datos_aseguramiento, fecha_alta_nuevo : date })}} />
                  </div>
              </div>
              <div className="col-sm">
                  <div className="mb-3">
                    <label className="form-label">Fecha de Baja</label>
                    <DatePicker dateFormat="MMMM d, yyyy" minDate={new Date()} selected={datos_aseguramiento.fecha_baja_nuevo} className="form-control" onChange={(date)=>{setDatosAseguramiento({ ...datos_aseguramiento, fecha_baja_nuevo : date })}} />
                  </div>
              </div>
            </div>





            <div className="row">
              <div className="col-sm">
              {
                <div className="mb-3">
                  <label className="form-label">Fecha de Aseguramiento</label>
                  <DatePicker dateFormat="MMMM d, yyyy" minDate={new Date()} selected={datos_aseguramiento.fecha_aseguramiento} className="form-control" onChange={(date)=>{setDatosAseguramiento({ ...datos_aseguramiento, fecha_aseguramiento : date })}} />
                </div>
              }
              </div>
              <div className="col-sm">
              {
                  //<div className="mb-3">
                  //  <label htmlFor="costo_alta" className="form-label">Costo de Alta</label>
                  //  <div className="input-group">
                  //    <span className="input-group-text">$</span>
                  //    <input type="text" className="form-control" readOnly={true} id="costo_alta" value={datos_aseguramiento.costo_alta} onChange={(e)=>{setDatosAseguramiento({ ...datos_aseguramiento, costo_alta : parseFloat(e.target.value) })}} />
                  //  </div>
                  //</div>
              }
              </div>
            </div>







            {
              // JSON.stringify(datos_aseguramiento)
            }









        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="success" onClick={asegurarTramite}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>






      {
        showModalAnexos && (
            <ModalAnexos uuid_tramite={uuid_tramite_modal} onHideModalAnexos={onHideModalAnexos} showModalAnexos={showModalAnexos} />
         )
      }



      {
        showModalCarga && (

            <ModalCargaMasiva showModalCarga={showModalCarga} handleCloseModalCarga={handleCloseModalCarga} />

         )
      }


      {
        showModalInforme && (

            <ModalInformeAseguramiento showModal={showModalInforme} handleClose={handleCloseModalInforme} />

         )
      }







          </>

      );
  

}

export default Aseguramiento
